var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"talk-to-your-data"},[_c('div',{staticClass:"chat-layout"},[_c('div',{staticClass:"d-flex flex-column"},[_c('ChatHistory',{staticClass:"chat-history"})],1),_c('div',{staticClass:"chat-main"},[_c('ChatContainer')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }